var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/controls/back-in-stock-section.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "product/templates/controls/back-in-stock-section.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_4 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("hasErrors")) {
var t_6 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_6);
if(t_1.hasOwnProperty("validatedField")) {
var t_7 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_7);
output += "\n\n<div class=\"dom-product-back-in-stock-notification\">\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"backInStockEligible")) {
output += "\n\n    ";
var t_8;
t_8 = (lineno = 6, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.analytics.productTypeSlug"]));
frame.set("brandAnalyticsSlug", t_8, true);
if(frame.topLevel) {
context.setVariable("brandAnalyticsSlug", t_8);
}
if(frame.topLevel) {
context.addExport("brandAnalyticsSlug", t_8);
}
output += "\n    ";
var t_9;
t_9 = (lineno = 7, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["pdp",runtime.contextOrFrameLookup(context, frame, "brandAnalyticsSlug"),"back in stock - view"]));
frame.set("bisClickAnalytics", t_9, true);
if(frame.topLevel) {
context.setVariable("bisClickAnalytics", t_9);
}
if(frame.topLevel) {
context.addExport("bisClickAnalytics", t_9);
}
output += "\n\n    <div class=\"o-row c-product-back-in-stock-notification\">\n\n        <div class=\"o-column o-extra-small--12 o-extra-large--10\">\n\n            <div class=\"c-product-back-in-stock-notification__arrow\"></div>\n\n            <div class=\"c-product-back-in-stock-notification__outer\">\n\n                ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"backInStockView") == "link") {
output += "\n\n                    <div class=\"c-product-back-in-stock-notification__link\">\n\n                        <p class=\"u-global-p c-product-back-in-stock-notification__p\">\n                            <span class=\"c-product-back-in-stock-notification__span--border\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"colorName"), env.opts.autoescape);
output += "</span>\n                            <span class=\"c-product-back-in-stock-notification__span--border\">";
output += runtime.suppressValue(env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"sizeTypeCode")), env.opts.autoescape);
output += "</span>\n                            <span class=\"c-product-back-in-stock-notification__span\">";
output += runtime.suppressValue((lineno = 24, colno = 90, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.controlsData.sizeLabel"])), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"sizeName"), env.opts.autoescape);
output += "</span>\n                        </p>\n\n                        <a href=\"#\" class=\"js-back-in-stock-link c-product-back-in-stock-notification__a\" ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "bisClickAnalytics"), env.opts.autoescape);
output += ">\n                            ";
output += runtime.suppressValue((lineno = 28, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_back-in-stock-link"])), env.opts.autoescape);
output += "\n                        </a>\n\n                    </div>\n\n                ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"backInStockView") == "signup") {
output += "\n\n                    ";
var t_10;
t_10 = (lineno = 35, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.profile.emailAddress"]));
frame.set("userEmail", t_10, true);
if(frame.topLevel) {
context.setVariable("userEmail", t_10);
}
if(frame.topLevel) {
context.addExport("userEmail", t_10);
}
output += "\n                    ";
var t_11;
t_11 = (lineno = 36, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.productControls.validation.values.backInStockEmailAddress",""]));
frame.set("validationEmail", t_11, true);
if(frame.topLevel) {
context.setVariable("validationEmail", t_11);
}
if(frame.topLevel) {
context.addExport("validationEmail", t_11);
}
output += "\n                    ";
var t_12;
t_12 = (lineno = 37, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.productControls.backInStockErrors.generalErrors"]));
frame.set("generalErrors", t_12, true);
if(frame.topLevel) {
context.setVariable("generalErrors", t_12);
}
if(frame.topLevel) {
context.addExport("generalErrors", t_12);
}
output += "\n\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "validationEmail")) {
output += "\n                        ";
var t_13;
t_13 = runtime.contextOrFrameLookup(context, frame, "validationEmail");
frame.set("defaultEmailValue", t_13, true);
if(frame.topLevel) {
context.setVariable("defaultEmailValue", t_13);
}
if(frame.topLevel) {
context.addExport("defaultEmailValue", t_13);
}
output += "\n                    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "userEmail")) {
output += "\n                        ";
var t_14;
t_14 = runtime.contextOrFrameLookup(context, frame, "userEmail");
frame.set("defaultEmailValue", t_14, true);
if(frame.topLevel) {
context.setVariable("defaultEmailValue", t_14);
}
if(frame.topLevel) {
context.addExport("defaultEmailValue", t_14);
}
output += "\n                    ";
;
}
else {
output += "\n                        ";
var t_15;
t_15 = "";
frame.set("defaultEmailValue", t_15, true);
if(frame.topLevel) {
context.setVariable("defaultEmailValue", t_15);
}
if(frame.topLevel) {
context.addExport("defaultEmailValue", t_15);
}
output += "\n                    ";
;
}
;
}
output += "\n\n                    ";
output += runtime.suppressValue((lineno = 47, colno = 41, runtime.callWrap(t_4, "displayGeneralErrors", context, [runtime.contextOrFrameLookup(context, frame, "generalErrors"),runtime.makeKeywordArgs({"id": "back-in-stock-notification-form"})])), env.opts.autoescape);
output += "\n\n                    <form novalidate id=\"back-in-stock-notification-form\" class=\"c-form c-product-back-in-stock-notification__form js-back-in-stock-notification-form\" method=\"post\" action=\"#\" data-parsley-validate aria-describedby=\"back-in-stock-notification-form_error\">\n\n                        <div class=\"o-row\">\n\n                            <div class=\"o-column o-extra-small--12\">\n\n                                <div class=\"c-form__field is-required ";
output += runtime.suppressValue((lineno = 55, colno = 80, runtime.callWrap(t_6, "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"validation")),"messages")),"backInStockEmailAddress")])), env.opts.autoescape);
output += "\">\n                                    <label for=\"back-in-stock-email-address\" class=\"c-form__label\">\n                                        ";
output += runtime.suppressValue((lineno = 57, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_back-in-stock-email-label"])), env.opts.autoescape);
output += "\n                                    </label>\n\n                                    <input data-parsley-type=\"email\"\n                                        type=\"email\"\n                                        id=\"back-in-stock-email-address\"\n                                        name=\"backInStockEmailAddress\"\n                                        class=\"c-form__email\"\n                                        value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "defaultEmailValue"), env.opts.autoescape);
output += "\"\n                                        aria-describedby=\"back-in-stock-email-address_error\"\n                                        ";
output += runtime.suppressValue((lineno = 67, colno = 55, runtime.callWrap(t_7, "validatedField", context, ["ERROR_CORE_INVALID_EMAIL_ADDRESS"])), env.opts.autoescape);
output += " />\n                                </div>\n\n                                ";
output += runtime.suppressValue((lineno = 70, colno = 51, runtime.callWrap(t_5, "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"validation")),"messages")),"backInStockEmailAddress"),runtime.makeKeywordArgs({"id": "back-in-stock-email-address"})])), env.opts.autoescape);
output += "\n\n                            </div>\n\n                        </div>\n\n                        <div class=\"o-row\">\n\n                            <div class=\"o-column o-extra-small--6 o-extra-large--8\">\n\n                                <div class=\"c-form__field\">\n\n                                    <button class=\"c-button-primary js-back-in-stock-submit\" type=\"submit\">\n                                        ";
output += runtime.suppressValue((lineno = 83, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_back-in-stock-submit"])), env.opts.autoescape);
output += "\n                                    </button>\n\n                                </div>\n\n                            </div>\n\n                            <div class=\"o-column o-extra-small--6 o-extra-large--4\">\n\n                                <div class=\"c-form__field\">\n\n                                    <button class=\"c-button-text c-button-text--adjacent js-back-in-stock-cancel\" type=\"submit\">\n                                        ";
output += runtime.suppressValue((lineno = 95, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_back-in-stock-cancel"])), env.opts.autoescape);
output += "\n                                    </button>\n\n                                </div>\n\n                            </div>\n\n                        </div>\n\n                    </form>\n\n                ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"backInStockView") == "success") {
output += "\n\n                    <div class=\"c-product-back-in-stock-notification__success\">\n\n                        <p>";
output += runtime.suppressValue(env.getFilter("markdown").call(context, (lineno = 110, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_back-in-stock-success"]))), env.opts.autoescape);
output += "</p>\n\n                    </div>\n\n                ";
;
}
;
}
;
}
output += "\n\n            </div>\n\n        </div>\n\n    </div>\n\n";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/controls/back-in-stock-section.j2"] , dependencies)